import React from 'react';
import PropTypes from 'prop-types';
import { useLocalisation } from '@3plearning/lingui-cdn';

import { Select, Cross } from '@helpers/icon-dictionary';

import { ProgressColors, ScoreBandColors } from '@components/view-key/view-key-colors';
import SvgIcon from '@components/svg-icon/svg-icon';

import useQuickSelector from '../hooks/use-quick-selector';
import { ModalContentRow, ModalContentHeader, AllCellsIcon, ColorBlock } from '../styled';

import getTranslations from '../translations';

const ProgressModalContent = props => {
  const { closeContextMenu } = props;

  /**
   * Hooks
   */
  const { i18n } = useLocalisation();
  const { cleanAssignmentHashKeys, selectProgressPercentageBetween, selectAllAssignments, selectCurrentAssigned } =
    useQuickSelector({ closeContextMenu });

  /**
   * Translations
   */
  const {
    SELECT_TEXT,
    ALL_CELLS_TEXT,
    ALL_CURRENTLY_ASSIGN_TEXT,
    PROGRESS_1_TO_20_TEXT,
    PROGRESS_21_TO_40_TEXT,
    PROGRESS_41_TO_60_TEXT,
    PROGRESS_61_TO_80_TEXT,
    PROGRESS_81_TO_100_TEXT,
    CLEAN_SELECTION_TEXT
  } = getTranslations({ i18n });

  // eslint-disable-next-line react/prop-types
  const renderModalContentRow = ({ dataTestId, onClickHandler, color, text }) => (
    <ModalContentRow
      data-testid={dataTestId}
      onClick={onClickHandler}
      role="button"
      tabIndex="-1"
    >
      <ColorBlock bgColor={color} />

      {text}
    </ModalContentRow>
  )

  return (
    <>
      <ModalContentHeader>{SELECT_TEXT}</ModalContentHeader>
      <ModalContentRow data-testid="select-all" onClick={selectAllAssignments} role="button" tabIndex="-1">
        <AllCellsIcon>
          <SvgIcon icon={Select} />
        </AllCellsIcon>
        {ALL_CELLS_TEXT}
      </ModalContentRow>

      <ModalContentRow role="button" tabIndex="-1" onClick={selectCurrentAssigned}>
        <ColorBlock data-testid="select-current-assigned" bgColor={ProgressColors.currentlyAssigned} />
        {ALL_CURRENTLY_ASSIGN_TEXT}
      </ModalContentRow>
      {renderModalContentRow({
        dataTestId: 'select-progress-1-to-20',
        onClickHandler: () => selectProgressPercentageBetween(1, 20),
        color: ScoreBandColors.completed1to20.default,
        text: PROGRESS_1_TO_20_TEXT
      })}
      {renderModalContentRow({
        dataTestId: 'select-progress-21-to-40',
        onClickHandler: () => selectProgressPercentageBetween(21, 40),
        color: ScoreBandColors.completed21to40.default,
        text: PROGRESS_21_TO_40_TEXT
      })}
      {renderModalContentRow({
        dataTestId: 'select-progress-41-to-60',
        onClickHandler: () => selectProgressPercentageBetween(41, 60),
        color: ScoreBandColors.completed41to60.default,
        text: PROGRESS_41_TO_60_TEXT
      })}
      {renderModalContentRow({
        dataTestId: 'select-progress-61-to-80',
        onClickHandler: () => selectProgressPercentageBetween(61, 80),
        color: ScoreBandColors.completed61to80.default,
        text: PROGRESS_61_TO_80_TEXT
      })}
      {renderModalContentRow({
        dataTestId: 'select-progress-81-to-100',
        onClickHandler: () => selectProgressPercentageBetween(81, 100),
        color: ScoreBandColors.completed81to100.default,
        text: PROGRESS_81_TO_100_TEXT
      })}
      <ModalContentRow data-testid="select-clean-cells" onClick={cleanAssignmentHashKeys} role="button" tabIndex="-1">
        <AllCellsIcon>
          <SvgIcon icon={Cross} />
        </AllCellsIcon>
        {CLEAN_SELECTION_TEXT}
      </ModalContentRow>
    </>
  );
};

ProgressModalContent.propTypes = {
  closeContextMenu: PropTypes.func.isRequired
};

export default ProgressModalContent;
